import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { Link } from "react-router-dom";

import {
  AddFormButton,
  ColumnHeading,
} from "../../../shared/components/TableElements";
import DataReactTable from "../../DataTable/components/DataReactTable";
import { useTranslation } from "react-i18next";
import DocumentRenewalsFormPopup from "./DocumentRenewalsFormPopup";
import useFetchData from "../../../shared/custom-hooks/useFetchData";
import { useSelector } from "react-redux";
import getUnixTime from "date-fns/getUnixTime";
import getDefaultFilterData from "../../../shared/constants/getDefaultFilterData";
import UserComponent from "../../../shared/components/table/components/UserComponent";
import { getListingDisplayDate } from "../../../shared/helpers";
import ProgressBar from "../../../shared/components/ProgressBar";
import DocRenewalsRowOptions from "./components/DocRenewalsRowOptions";
import Snackbar from "../../../shared/components/Snackbar";
import { NATEXT } from "../../../shared/constants";
import { useAuth } from "../../../contexts/AuthContext";

const DocumentRenewalsTable = () => {
  const { t } = useTranslation("common");
  const { isViewOnly } = useAuth();
  const { minDate } = useSelector((state) => state.columns);
  const rowData = useSelector((state) => state.filter.rowData);

  const [showDocRenewalFormPopup, setShowDocRenewalFormPopup] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");

  useFetchData({
    startDate: 0,
    endDate: getUnixTime(new Date()),
    query: "get_all_document_renewal_data",
    sortIndex: 3,
  });

  const { defaultContainsData, defaultRangeData, defaultStatusData } =
    getDefaultFilterData();

  const columnHeaders = useMemo(
    () => [
      {
        id: 1,
        Header: t("name"),
        accessor: "name",
        width: 130,
        disableFilters: true,
        //dragDisabled: true,
        Cell: ({ row }) => (
          <UserComponent
            userName={row.original.name}
            //groupName={row.original.group_name}
            userId={row.original.user_id}
            userImg={row.original.user_img}
            orgId={row.original.org_id}
          />
        ),
      },
      {
        id: 2,
        Header: t("doc_name"),
        accessor: "document_name",
        //accessorId: "task_name",
      },
      {
        id: 3,
        Header: t("status"),
        accessor: "status",
        //disableSortBy: true,
        Cell: ({ row }) => {
          //console.log(row);
          const { due_on_date } = row.original;
          let currentDate = Math.floor(Date.now() / 1000);
          let dueIn = ((due_on_date - currentDate) / (60 * 60 * 24)).toFixed(0);
          return (
            <DocRenewalStatusComponent
              percentage={row.original.PERCENTAGE}
              days={dueIn}
            />
          );
        },
      },
      {
        id: 4,
        Header: `${t("expiry")}`,
        accessor: "due",
        //disableSortBy: true,
        Cell: ({ row }) => {
          const dueOnDate = row.original.due_on_date
            ? getListingDisplayDate(row.original.due_on_date) //dueDate.toLocaleDateString("en-US")
            : NATEXT;
          return <div>{dueOnDate}</div>;
        },
      },
      {
        id: 5,
        Header: `${t("last_renewed")}`,
        accessor: "last_service",
        disableSortBy: true,
        Cell: ({ row }) => {
          const startDate = row.original.start_date
            ? getListingDisplayDate(row.original.start_date) //dueDate.toLocaleDateString("en-US")
            : NATEXT;
          return <div>{startDate}</div>;
        },
      },
      {
        id: "edit",
        Header: "",
        accessor: "edit",
        accessorId: "edit",
        Cell: ({ row }) => <DocRenewalsRowOptions rowData={row?.original} />,
        disableSortBy: true,
      },
    ],
    []
  );

  const initialData = useMemo(
    () => ({
      // status: {
      //   column: "status",
      //   name: t("status"),
      //   ...defaultStatusData,
      // },
      document_name: {
        column: "document_name",
        name: t("doc_name"),
        ...defaultContainsData,
      },
      daysRemaining: {
        column: "daysRemaining",
        name: t("days_remaining"),
        ...defaultRangeData,
      },
      //   odoRemaining: {
      //     column: "odoRemaining",
      //     name: t("odo_remaining"),
      //     ...defaultRangeData,
      //   },
      //   lastServiceOdo: {
      //     column: "lastServiceOdo",
      //     name: t("last_service_odo"),
      //     ...defaultRangeData,
      //   },
      //   lastServiceDate: {
      //     column: "lastServiceDate",
      //     name: t("last_service_date"),
      //     dateOption: "all_time",
      //     from: new Date(minDate * 1000),
      //     to: new Date(),
      //     isFiltered: false,
      //     mode: "custom",
      //   },
      //   dueOdo: {
      //     column: "dueOdo",
      //     name: t("due_odo"),
      //     ...defaultRangeData,
      //   },
      dueDate: {
        column: "dueDate",
        name: t("due_date"),
        dateOption: "all_time",
        from: new Date(minDate * 1000),
        to: new Date(),
        isFiltered: false,
        mode: "custom",
      },
    }),
    [minDate]
  );

  useEffect(() => {
    if (snackbarMsg) {
      setShowSnackbar(true);
      setTimeout(() => {
        setShowSnackbar(false);
        setSnackbarMsg("");
      }, 5000);
    }
  }, [snackbarMsg]);

  const handleAddDocRenewal = () => {
    setShowDocRenewalFormPopup(true);
  };

  const reactTableData = {
    tableHeaderData: columnHeaders,
    tableRowsData: rowData,
  };

  return (
    <>
      {/* {showExplorePopup && (
        <ExplorePopup
          showPopup={showExplorePopup}
          setShowPopup={setShowExplorePopup}
          exploreLink={"https://embed.getsmartcue.com/IYBSWVIM"}
        />
      )} */}

      {showDocRenewalFormPopup && (
        <DocumentRenewalsFormPopup
          showPopup={showDocRenewalFormPopup}
          setShowPopup={setShowDocRenewalFormPopup}
          type={"add"}
          setSnackbarMsg={setSnackbarMsg}
        />
      )}
      {showSnackbar && (
        <Snackbar
          showSnackbar={showSnackbar}
          setShowSnackbar={setShowSnackbar}
          message={snackbarMsg}
          //snackbarType={snackbarData.type}
        />
      )}
      <Container>
        <Row className="mx-1 d-flex align-items-center justify-content-around p-0 m-0">
          <Col className="d-flex align-items-center gap-2">
            <ColumnHeading>{t("user_renewals")}</ColumnHeading>

            {/* <LinkSpan
              onClick={() => setShowExplorePopup(true)}
              style={{ alignSelf: "end" }}
            >
              {t("explore")}
            </LinkSpan> */}
          </Col>
          <Col
            sm={3}
            className="d-flex justify-content-end align-items-center mb-1"
          >
            {/* <Link to={"/reminders/maintenancereminders/addnew"}> */}
            {!isViewOnly && (
              <AddFormButton
                id="add-doc-renewal-btn"
                onClick={handleAddDocRenewal}
              >
                {t("add_user_renewal")}
              </AddFormButton>
            )}
            {/* </Link> */}
          </Col>
        </Row>
        <Row>
          <DataReactTable
            reactTableData={reactTableData}
            //valuesArray={fillupsValuesArray}
            initialData={initialData}
            //defaultColumns={defaultColumns}
          />
        </Row>
      </Container>
    </>
  );
};

export default DocumentRenewalsTable;

const DocRenewalStatusComponent = ({ percentage, days }) => {
  const { t } = useTranslation("common");
  //let distanceUnit = useSelector((state) => state.units.distance);

  let daysText = days
    ? `${percentage >= 100 ? t("overdue_by_sm") : t("due_in_sm")} ${Math.abs(
        days
      )} ${t("days_sm", { count: +days })}`
    : "";
  //let bottomText = "";
  //   if (distanceText === "" && daysText !== "") {
  //     bottomText = daysText;
  //   } else if (distanceText !== "" && daysText === "") {
  //     bottomText = distanceText;
  //   } else if (distanceText !== "" && daysText !== "") {
  //     bottomText = `${t("due_in_sm")} ${distanceVal} ${getDistanceUnit(
  //       distanceUnit
  //     )} ${t("or")} ${days} ${t("days_sm", { count: +days })}`;
  //   }
  let statusText = "SCHEDULED";
  let color = "#5CB85C";
  let background = "";
  if (percentage <= 90) {
    statusText = "SCHEDULED";
    color = "#5CB85C";
  } else if (percentage > 90 && percentage < 100) {
    statusText = "DUE SOON";
    color = "#F0AD4E";
  } else if (percentage >= 100) {
    statusText = "OVERDUE";
    color = "#D9534F";
    //daysText = "";
  }
  return (
    <div
      className="d-flex flex-column justify-content-center gap-2"
      style={{ paddingRight: "1.25rem" }}
    >
      <ProgressBar color={color} now={percentage} />

      {daysText && <p style={{ fontSize: "11px" }}>{daysText}</p>}
    </div>
  );
};
